// extracted by mini-css-extract-plugin
module.exports = {"container":"AcceptedCheckTypes_container__Mo8VO","sectionTitle":"AcceptedCheckTypes_sectionTitle__Fx-CE"};